import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
    children: ReactNode;
}

interface State {
    error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            error: null,
        };
    }

    static getDerivedStateFromError(error: Error): State {
        return {
            error,
        };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        // Log error to an error reporting service
        console.error(error, errorInfo);
    }

    render(): ReactNode {
        const { error } = this.state;
        if (error) {
            return (
                <div>
                    <h2>Something went wrong.</h2>
                    <p>{error.toString()}</p>
                </div>
            );
        }

        return this.props.children;
    }
}
